export const sidebarItems = [
  {
    title: "Пользователи",
    to: { name: "users-list" },
    iconName: "UserIcon",
  },
  {
    title: "Тарифы",
    to: { name: "tarif" },
    iconName: "TarifsIcon",
  },
  {
    title: "Настройки",
    to: { name: "settings" },
    iconName: "SettingsIcon",
  },
  {
    title: "Отчеты",
    to: { name: "reports" },
    iconName: "ReportsIcon",
  },
];

export function getSidebarItem(name) {
  return sidebarItems.find((si) => si.name === name);
}
